import { HomeIcon } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {Link} from "react-router";

export default function NotFound() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 text-center">
      <div className="max-w-md space-y-6">
        <h1 className="text-6xl font-bold">404</h1>

        <h2 className="text-2xl font-semibold">Page Not Found :(</h2>

        <p className="text-muted-foreground">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <Link
          to="/"
          className={cn(
            buttonVariants({ size: "lg", variant: "default" }),
            "mx-auto flex max-w-min items-center gap-2",
          )}
        >
          <HomeIcon className="size-4" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
